import React from 'react'
import { Box, IconButton } from '@mui/material'
import ReplyIcon from '@mui/icons-material/Reply'
import ReplyAllIcon from '@mui/icons-material/ReplyAll'
import ForwardIcon from '@mui/icons-material/Forward'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'

const EmailToolbar = ({ selectedItem, selectedBox, onReply, onReplyAll, onForward, onDelete, onEdit }) => {
  const isDraft = selectedBox === 'DRAFT'
  const hasSelection = !!selectedItem

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', height: '10%', width: '100%' }}>
      {isDraft && (
        <Box sx={{ marginRight: '2px' }}>
          <IconButton disabled={!hasSelection} sx={{ marginTop: '10px' }} color='primary' onClick={onEdit} size='small'>
            <EditIcon />
          </IconButton>
        </Box>
      )}

      <Box sx={{ marginRight: '2px' }}>
        <IconButton disabled={!hasSelection} sx={{ marginTop: '10px' }} color='primary' onClick={onDelete} size='small'>
          <DeleteIcon />
        </IconButton>
      </Box>

      <Box sx={{ marginRight: '2px' }}>
        <IconButton
          disabled={!hasSelection || isDraft}
          sx={{ marginTop: '10px' }}
          color='primary'
          onClick={onReply}
          size='small'
        >
          <ReplyIcon />
        </IconButton>
      </Box>

      <Box sx={{ marginRight: '2px' }}>
        <IconButton
          disabled={!hasSelection || isDraft}
          sx={{ marginTop: '10px' }}
          color='primary'
          onClick={onReplyAll}
          size='small'
        >
          <ReplyAllIcon />
        </IconButton>
      </Box>

      <Box sx={{ marginRight: '2px' }}>
        <IconButton
          disabled={!hasSelection}
          sx={{ marginTop: '10px' }}
          color='primary'
          onClick={onForward}
          size='small'
        >
          <ForwardIcon />
        </IconButton>
      </Box>
    </Box>
  )
}

export default EmailToolbar
